<template>
  <div>
    <multiselect
      v-model="value"
      :options="options"
      searchable="true"
      placeholder="Select Group"
      :mode="type && types.indexOf(type) > -1 ? type : 'single'"
      @change="onChange($event)"
    >
      <template v-slot:multiplelabel="{ values }" v-if="type == 'multiple'">
        <div class="multiselect-multiple-label">
          {{ values.length }} group(s) selected
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import api from "@/api/index";
import { useStore } from "@/store";
const store = useStore();
import { Roles } from "@/helpers/enums/Roles";

export default {
  components: {
    Multiselect,
  },
  props: {
    site: {
      type: String,
      required: true,
    },
    group: {
      type: Object,
    },
    type: {
      type: String,
      default: "single",
    },
    selectedGroupsData: {}
  },
  data() {
    return {
      value: null,
      groups: [],
      types: ["single", "multiple"],
    };
  },
  watch: {
    site(value) {
      this.groups = [];
      this.value = null;
      if (value) {
        this.getGroups();
      }
    },
    selectedGroupsData(value) {
      if(value.length === 0) {
        this.value = [];
      }
    },
  },
  computed: {
    options() {
      return this.groups.map((f) => {
        return {
          label: f.name,
          value: { label: f.name, value: f.groupGuid },
        };
      });
    },
  },
  methods: {
    async getGroups() {
      let guid = this.site.key;
      if(!guid) {
        guid = this.site.value;
      }
      if (
        (guid &&
        Object.keys(guid).length === 0 &&
        Object.getPrototypeOf(guid) === Object.prototype) || 
        typeof guid === 'undefined'
      ) {
        this.groups = [];
      } else {
        const res = await api.groups.getSiteGroups(guid);
        this.groups = res.data.entityData;
      }
    },
    onChange(event) {
      this.$emit("input", event);
      this.$emit("change", event);
    },
  },
  async mounted() {
    this.getGroups();
    let role = (store.state.auth.user.find((f) => f.type == "role") || {})
      .value;
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      role = Roles.AGMSAdmin;
      // role = Roles.SiteAudit;
      // role = Roles.GroupAdmin;
      // role = Roles.SiteAdmin;
    }
    if (role == Roles.SiteAdmin) {
      let site = (store.state.auth.user.find((f) => f.type == "SiteGuid") || {})
        .value;
      const res = await api.groups.getSiteGroups(JSON.parse(site)[0]);
      this.groups = res.data.entityData;
    }
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped></style>
